export default async function uploadLogo(apiBase, token, file, code_etablissement) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('code_etablissement', code_etablissement);

    const response = await fetch(`${apiBase}/settings/logo`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        body: formData,
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Upload failed: ${errorText}`);
    }

    return await response.json();
}
